"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProdHqConfig = exports.getProdApiConfig = exports.getSitHqConfig = exports.getSitApiConfig = exports.getDevHqConfig = exports.getDevApiConfig = void 0;
var heimdallEndpoints = {
    heimdallTokenFetch: '/v1/token/get',
    heimdallLogin: '/v1/login/code',
    v2Login: '/api/auth/login/code',
};
var getDevApiConfig = function () { return ({
    v2Url: 'https://v2dev.hiver.space',
    heimdallUrl: 'https://dev.hiver.space/api/heimdall-api',
    apiEndpoints: heimdallEndpoints,
}); };
exports.getDevApiConfig = getDevApiConfig;
var getDevHqConfig = function () { return ({
    v2Url: 'https://v2dev.hiver.space',
    heimdallUrl: 'https://dev.hiver.space/api/heimdall-api2',
    apiEndpoints: heimdallEndpoints,
}); };
exports.getDevHqConfig = getDevHqConfig;
var getSitApiConfig = function (APP_ENV) { return ({
    v2Url: "https://v2".concat(APP_ENV, ".hiver.space"),
    heimdallUrl: "https://".concat(APP_ENV, ".hiver.space/api/heimdall-api"),
    apiEndpoints: heimdallEndpoints,
}); };
exports.getSitApiConfig = getSitApiConfig;
var getSitHqConfig = function (APP_ENV) { return ({
    v2Url: "https://v2".concat(APP_ENV, ".hiver.space"),
    heimdallUrl: "https://".concat(APP_ENV, ".hiver.space/api/heimdall-api2"),
    apiEndpoints: heimdallEndpoints,
}); };
exports.getSitHqConfig = getSitHqConfig;
var getProdApiConfig = function () { return ({
    v2Url: "https://v2.hiverhq.com",
    heimdallUrl: "https://heimdall.hiverapi.com",
    apiEndpoints: heimdallEndpoints,
}); };
exports.getProdApiConfig = getProdApiConfig;
var getProdHqConfig = function () { return ({
    v2Url: "https://v2.hiverhq.com",
    heimdallUrl: "https://heimdall2.hiverhq.com",
    apiEndpoints: heimdallEndpoints,
}); };
exports.getProdHqConfig = getProdHqConfig;
//# sourceMappingURL=index.js.map